/**
 * 表格翻页滚动 Mixin
 * 用于处理表格翻页后自动滚动到顶部的问题
 * 
 * 使用方式：
 * 1. 在表格组件中引入：import tableScrollMixin from '@/mixins/tableScrollMixin'
 * 2. 在 mixins 中添加：mixins: [tableScrollMixin]
 * 3. 确保表格组件有 ref="table" 和 currentPage prop
 */
export default {
  watch: {
    // 监听当前页码变化，翻页时自动滚动到顶部
    currentPage: {
      handler() {
        this.$nextTick(() => {
          this.scrollTableToTop()
        })
      }
    }
  },
  methods: {
    /**
     * 将表格滚动到顶部
     * 支持 el-table 的 bodyWrapper
     */
    scrollTableToTop() {
      if (this.$refs.table && this.$refs.table.bodyWrapper) {
        this.$refs.table.bodyWrapper.scrollTop = 0
      }
    }
  }
}

